import { ReactElement, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CheckCode } from "../data/ScavengerHunts";

const CongratsPage = ({
  solutionCode,
  text,
}: {
  solutionCode: string;
  text: ReactElement;
}) => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!CheckCode(code ?? "", solutionCode)) {
      navigate("/");
    }
  }, [code]);

  return (
    <div className="scavengerhunt-text congrats-text">
      <h1>Glückwunsch!</h1>
      <p>
        Der Code war <b>{code?.toUpperCase()}</b>!
      </p>
      {text}
    </div>
  );
};

export default CongratsPage;
